const atgHomepageMyOrdersContent = {
  title: 'My Orders',
  tabs: {
    searchByDate: 'Search Order By Date',
    searchByOrder: 'Search Order By Order# or PO#',
    searchByStatus: 'Search By Status',
  },
  labels: {
    fromDate: 'From',
    toDate: 'To',
    separatorOr: 'OR',
    salesOrderNumber: 'Enter ATG Order Number',
    purchaseOrderNumber: 'Enter Customer PO',
    invoiceNumber: 'Enter Invoice Number',
    orderStatus: 'Order Status',
    selectOrderStatus: 'Select Order Status',
    past90Days: 'Show past 15 Orders (Within 90 Days)',
    allOrders: 'All Orders',
    openOrders: 'Open Orders',
    shippedOrders: 'Shipped Orders',
    cancelledOrders: 'Cancelled Orders',
    closedOrders: 'Closed Orders',
    past30DayOrders: 'Show past 30 Days Orders',
    past60DayOrders: 'Show past 60 Days Orders',
    past90DayOrders: 'Show past 90 Days Orders',
  },
  button: {
    search: 'Search',
    reset: 'Reset',
  },
};

export const atgHomepageMyOrders = {
  ...atgHomepageMyOrdersContent,
  atgHomepageMyOrders: atgHomepageMyOrdersContent,
};
